import React from 'react';
import {
    useGroupCallVolValue
} from '../../../../context/CallContext/GroupCallVolumesContext/context';
import AriaButton from '../../../AriaComponents/AriaButton';
import { useConferenceMethods } from '../../ConferenceHooks';
import { RoomMember } from '../../../../types';
import { useCallContext } from '../../../../context/CallContext/context';
import { useTypedSelector } from '../../../../redux/hooks';
import { selectCallerDisplayNameGeneric } from '../../../../redux/slices';

interface Props {
    roomMember: RoomMember;
}

const ConferenceMember: React.FC<Props> = ({ roomMember }) => {
    const { call } = useCallContext();
    const { speakingMap } = useGroupCallVolValue();

    const speaking = speakingMap[roomMember.id] || false;

    const { name } = useTypedSelector(state => selectCallerDisplayNameGeneric(state, roomMember.name));

    const { kickUser } = useConferenceMethods();

    return (
        <li>
            <p data-speaking={speaking ? 'yes' : null} title={name}>
                {name}
            </p>
            {call.isAdmin ? (
                <AriaButton
                    onClick={() => {
                        kickUser(roomMember.id);
                    }}
                >
                    <p>Remove</p>
                </AriaButton>
            ) : null}
        </li>
    );
};

export default ConferenceMember;
